export const TournamentStatus = Object.freeze({
  CREATED : 1,
  OPEN_FOR_INSCRIPTIONS: 2,
  CLOSED_FOR_INSCRIPTIONS: 3,
  FINISHED: 4,
  IN_PROGRESS: 5,
  CANCELLED: 6
});

export const TORNEO_RITMOS = ['PENSADO', 'RÁPIDO', 'BLITZ'];

export const TORNEO_TIPOS = [
  'Regular (Abierto)',
  'Regular (Cerrado)',
  'Clasificatorio',
  'Torneo de Campeones',
  'Por Equipos',
  'Ascenso',
  'Clasificatorio Aficionados',
];

export const TORNEO_SISTEMAS = ['Suizo', 'Americano', 'Match'];

export const TORNEO_ESTADOS = [
  'Creado',
  'Inscripción Abierta',
  'Inscripción Cerrada',
  'En Curso',
  'Finalizado',
];